import { Box, IconButton, makeStyles } from '@material-ui/core';
import { MouseEventHandler } from 'react';
import './index.css';

type Sizes = 'small' | 'medium' | 'large';

export interface IAIButton {
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  size?: Sizes;
}

const useStyles = makeStyles(theme => ({
  commonIconButton: {
    position: 'absolute',
    borderRadius: '50%',
    fontWeight: 700,
    font: 'poppins',
    fontSize: '12px',
    lineHeight: '15.4px',
    color: 'white',
    textAlign: 'center',
  },
  activeIconButton: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.85,
    },
  },
  disableIconButton: {
    position: 'absolute',
    '&:disabled': {
      color: theme.palette.type === 'dark' ? theme.palette.grey[500] : 'white',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.grey[700]
          : theme.palette.grey[300],
    },
  },
  outerCircle: {
    position: 'absolute',
    borderRadius: '50%',
    margin: 'auto',
    opacity: '20%',
    border: `0.5px solid ${theme.palette.primary.main}`,
  },
  radarCircleBoxShadow: {
    boxShadow: `0 0 10px 0px ${theme.palette.primary.main}`,
  },
}));

const AIButton: React.FC<IAIButton> = ({
  label,
  onClick,
  disabled,
  size = 'small',
}) => {
  const {
    commonIconButton,
    disableIconButton,
    activeIconButton,
    outerCircle,
    radarCircleBoxShadow,
  } = useStyles();

  const sizeMap = {
    default: 28,
    small: 28,
    medium: 36,
    large: 40,
  };

  const sizeOuter = sizeMap[size] || sizeMap.default;
  const sizeInner = Math.floor(sizeOuter * 0.864);
  const iconButtonClasses = `${commonIconButton} ${
    disabled ? disableIconButton : activeIconButton
  }`;

  return (
    <Box position="relative" height={sizeInner} width={sizeInner}>
      <Box
        position="absolute"
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        {!disabled && (
          <Box
            className={`radar-circle ${radarCircleBoxShadow}`}
            style={{
              height: sizeOuter,
              width: sizeOuter,
            }}
          />
        )}
        <Box
          className={outerCircle}
          style={{
            height: sizeOuter,
            width: sizeOuter,
          }}
        />

        <IconButton
          color="primary"
          onClick={onClick}
          disabled={disabled}
          className={iconButtonClasses}
          style={{
            height: sizeInner,
            width: sizeInner,
          }}
        >
          {label}
        </IconButton>
      </Box>
    </Box>
  );
};

export default AIButton;
